import { EMPTY_CHANGES_COLUMN_FILTERS } from '../components/ChangesTable';
import { apiService } from '../services/api';
import type { DashboardSearchContext } from './dashboardSearchParams';
import { buildChangesQueryParams } from './dashboardSearchParams';

export const FOCUS_CHANGE_SEARCH_PARAM = 'focusChange';

/** ID estável da seção — reutilizável em Dashboard e futuras rotas com a tabela. */
export const CHANGES_TABLE_SECTION_ID = 'mudancas-legislativas-recentes';

export const changeTableRowId = (changeId: number) => `legislation-change-row-${changeId}`;

type ChangesQueryParams = Parameters<typeof apiService.getChanges>[0];

export function buildNotificationFocusPath(changeId: number, basePath = '/dashboard'): string {
  return `${basePath}?${FOCUS_CHANGE_SEARCH_PARAM}=${changeId}`;
}

export function buildFocusRelaxContext(
  publicationDateMin: string | null,
): DashboardSearchContext {
  return {
    period: { preset: 'total', start: null, end: null },
    publicationDateMin,
    agencyNames: [],
    agencyKeys: [],
    assunto: null,
    keyword: null,
    columnFilters: { ...EMPTY_CHANGES_COLUMN_FILTERS },
    monitoredNormAssunto: false,
    monitoredAgency: false,
    greeningQaOnly: false,
  };
}

export function formatChangeFocusLabel(change: {
  id: number;
  law?: string | null;
  title?: string | null;
}): string {
  const law = change.law?.trim();
  if (law) return law;
  const title = change.title?.trim();
  if (title) return title.length > 80 ? `${title.slice(0, 77)}…` : title;
  return `Mudança #${change.id}`;
}

export async function findChangeListPage(
  changeId: number,
  params: ChangesQueryParams,
  pageSize: number,
): Promise<number | null> {
  let page = 1;
  while (page <= 100) {
    const response = await apiService.getChanges({ ...params, page, page_size: pageSize });
    if (response.data?.some((row) => row.id === changeId)) {
      return page;
    }
    if (!response.total_pages || page >= response.total_pages) {
      break;
    }
    page += 1;
  }
  return null;
}

export async function findChangeListPageForContext(
  changeId: number,
  ctx: DashboardSearchContext,
  sortBy: string,
  sortOrder: string,
  pageSize: number,
): Promise<number | null> {
  const params = buildChangesQueryParams(ctx, {
    sort_by: sortBy,
    sort_order: sortOrder,
  }) as ChangesQueryParams;
  return findChangeListPage(changeId, params, pageSize);
}

export function scrollToChangesTableSection() {
  document.getElementById(CHANGES_TABLE_SECTION_ID)?.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  });
}

export function scrollToChangeRow(changeId: number) {
  const el = document.getElementById(changeTableRowId(changeId));
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
